import gql from "graphql-tag";

export { catalogCategoriesQuery } from "@/gql/catalog-categories.queries";

export const dashboardCategoriesQuery = gql`
  query dashboardCategories {
    productCategories {
      id
      description
      parent
      children
    }
  }
`;

export const dashboardOrdersQuery = gql`
  query dashboardOrders($filters: Filter, $page: Int!, $perPage: Int) {
    orders(
      orderBy: { column: "documentDate", direction: desc }
      filters: $filters
      page: $page
      first: $perPage
    ) {
      data {
        id
        number
        contract {
          name
          currency {
            symbol
          }
        }
        amount {
          value
          currency {
            symbol
            code
          }
        }
        status
        payStatus
        name
        documentDate
      }
    }
  }
`;

export const dashboardMutualSettlementsQuery = gql`
  query dashboardMutualSettlements(
    $page: Int!
    $mutualPerPage: Int!
    $settlementsFilters: SettlementsFilters
  ) {
    mutualSettlements(filters: $settlementsFilters, page: $page, perPage: $mutualPerPage) {
      mutualSettlements {
        id
        type
        documentDate
        amount
        operation
        currency {
          symbol
        }
      }
    }
  }
`;

export const contractsQuery = gql`
  query contracts($companyId: ID) {
    contracts(companyId: $companyId) {
      id
      name
      currency {
        symbol
      }
      balanceAmount
    }
  }
`;
